import { render, staticRenderFns } from "./what-you-get.vue?vue&type=template&id=20c24913&"
import script from "./what-you-get.vue?vue&type=script&lang=js&"
export * from "./what-you-get.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports